<mat-card appearance="outlined">
    <mat-card-content>
        <div class="d-flex justify-content-center" *ngIf="sending">
            <mat-spinner></mat-spinner>
        </div>

        @if(!sending) {
        <form [formGroup]="form">
            <mat-form-field appearance="outline">
                <mat-label>Subject</mat-label>
                <input matInput placeholder="Subject" formControlName="subject" />
                <mat-error *ngIf="form.controls.subject.errors?.['required']">Subject is required</mat-error>
            </mat-form-field>

            @if (editor) {
            <div class="m-b-1 NgxEditor__Wrapper">
                <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
                <ngx-editor [editor]="editor" formControlName="body"></ngx-editor>
            </div>
            }
            @if(errorMessage){
  <div  class="mat-elevation-z2 alert-error" style="margin: 16px 0; padding: 16px; border-radius: 4px; position: relative;">
    {{ errorMessage }}
    <button mat-icon-button aria-label="Dismiss" (click)="errorMessage = null"
      style="position: absolute; top: 8px; right: 8px;">
      <mat-icon>close</mat-icon>
    </button>
  </div>
}
            @if (attachments.length > 0) {
             <div class="attachments-grid">
  @for (attachment of attachments; track $index) {
    <mat-card class="file-panel m-b-1">
      <mat-card-content class="file-panel-content">
        <div class="file-header">
          <mat-icon fontSet="material-symbols-outlined" class="upload">attach_file</mat-icon>
          <span class="file-description">{{attachment.messageDocument.fileDescription}}</span>
        </div>
        <div class="file-details">
          @for(file of attachment.files; track $index) {
            <div class="file-info">{{file.name}} ({{file.size | byteFormat}})</div>
          }
        </div>
        <div class="file-actions">
          <button mat-icon-button (click)="deleteAttachment(attachment.messageDocument.id)" aria-label="Remove file">
            <mat-icon fontSet="material-symbols-outlined" class="delete">delete</mat-icon>
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  }
</div>
            }
            <mat-card-actions class="action-bar">

                <button mat-button mat-stroked-button (click)="cancel()">Cancel</button>
                <span class="action-links">
                    <button mat-button mat-stroked-button [disabled]="sending" (click)="addAttachment()" class="m-r-2px"><mat-icon>attach_file</mat-icon>Add Attachment</button>
                    <button mat-button mat-flat-button (click)="send()" [disabled]="form.invalid">Send</button>
                </span>
            </mat-card-actions>
        </form>
        }
    </mat-card-content>
</mat-card>
